import { Alert, Button, Card, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import filterListApi from 'src/component/app/filterList/FilterListApi'
import { FilterListBean } from '../../../api/api'
import { FormDataType, formDataLoader } from '../../../util/FormDataLoader'

const FormItem = Form.Item
const Option = Select.Option
const TextArea = Input.TextArea

const formInfoItems: FormDataType[] = [
    FormDataType.Countries,
]

const FilterListCreate = () => {

    const [info, setInfo] = useState({
        countries: [],
    })

    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const navigateTo = useNavigate()

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await filterListApi.create(values)
            navigateTo('/filter-list')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input />
            </FormItem>
            <FormItem
                required
                name="filterType"
                label="Filter list type"
            >
                <Select placeholder="Select filter list type">
                    {Object.values(FilterListBean.FilterTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="filterMode"
                label="Filter list mode"
            >
                <Select placeholder="Select filter list mode">
                    {Object.values(FilterListBean.FilterModeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="data"
                label="Filter data"
            >
                <TextArea rows={4} />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/filter-list')}>Cancel</Button>
        </div>
    </Form>
}

export default FilterListCreate


// WEBPACK FOOTER //
// ./src/component/app/filterList/FilterListCreate.tsx